var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 22 12","fill":"none"}},[_c('path',{attrs:{"d":"M1 1L11 11L21 1","stroke":"var(--geist-foreground)","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }